import { Button, CircularProgress } from "@mui/material";

import {Box, TextField, Typography} from "@mui/material";
import {useState} from "react";
import {Link as RouterLink, useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import BoxedLayout from "../components/common/BoxedLayout";
import {passcodeRequest} from "../services/dataService";




const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false)

  const history = useHistory();

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    console.log("Sending OTP to:", email);
    const response = await passcodeRequest(email);
    console.log("OTP Sent successfully", response);
    history.push(`/forgot-password-submit/${email}`);
  } catch (error) {
    console.error("Error sending OTP:", error);
    toast.error("Please enter valid email address.");
  } finally {
    setLoading(false);
  }
};


  return (
    <BoxedLayout>
      <Typography component="h1" variant="h5">
        Get validation code
      </Typography>
      <Typography marginTop={3}>
        To get a validation code, enter the E-mail address associated to your
        account.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} marginTop={3}>
        <TextField
          margin="normal"
          fullWidth
          required
          id="Email"
          label={"E-mail Address"}
          name="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
          type="email"
          autoComplete="off"
        />
       <Button
  fullWidth
  size="large"
  variant="contained"
  color="primary"
  sx={{ mt: 2 }}
  type="submit"
  disabled={loading}
>
  {loading ? <CircularProgress size={24} color="inherit" /> : "Send OTP"}
</Button>

        <Button
          component={RouterLink}
          to={`/`}
          color="primary"
          fullWidth
          size="large"
          sx={{mt: 2}}
        >
          Back to login
        </Button>
      </Box>
    </BoxedLayout>
  );
};

export default ForgotPassword;
